export const FETCH_TASK_FILE_CONFIGS = 'FETCH_TASK_FILE_CONFIGS';
export const FETCHING_TASK_FILE_CONFIGS = 'FETCHING_TASK_FILE_CONFIGS';
export const FETCH_TASK_FILE_CONFIGS_SUCCESS = 'FETCH_TASK_FILE_CONFIGS_SUCCESS';
export const FETCH_TASK_FILE_CONFIGS_FAILED = 'FETCH_TASK_FILE_CONFIGS_FAILED';

// export const FETCH_TASK_FILE_CONFIG = 'FETCH_TASK_FILE_CONFIG';
// export const FETCHING_TASK_FILE_CONFIG = 'FETCHING_TASK_FILE_CONFIG';
// export const FETCH_TASK_FILE_CONFIG_SUCCESS = 'FETCH_TASK_FILE_CONFIG_SUCCESS';
// export const FETCH_TASK_FILE_CONFIG_FAILED = 'FETCH_TASK_FILE_CONFIG_FAILED';

export function fetchTaskFileConfigs() {
  return {
    type: FETCH_TASK_FILE_CONFIGS,
  };
}

export function fetchingTaskFileConfigs() {
  return {
    type: FETCHING_TASK_FILE_CONFIGS,
  };
}

export function fetchTaskFileConfigsSuccess(taskfileconfigs) {
  return {
    type: FETCH_TASK_FILE_CONFIGS_SUCCESS,
    taskfileconfigs,
  };
}

export function fetchTaskFileConfigsFailed(err) {
  return {
    type: FETCH_TASK_FILE_CONFIGS_FAILED,
    message: err.message,
  };
}

// export function fetchTask(jobId) {
//   return {
//     type: FETCH_TASK_FILE_CONFIG,
//     jobId,
//   };
// }
//
// export function fetchingTask(jobId) {
//   return {
//     type: FETCHING_TASK_FILE_CONFIG,
//     jobId,
//   };
// }
//
// export function fetchTaskSuccess(job) {
//   return {
//     type: FETCH_TASK_FILE_CONFIG_SUCCESS,
//     job,
//   };
// }
//
// export function fetchTaskFailed(jobId,err) {
//   return {
//     type: FETCH_TASK_FILE_CONFIG_FAILED,
//     jobId,
//     message: err.message,
//   };
// }



// WEBPACK FOOTER //
// ./src/actions/taskfileconfigs.js